import { ApiService } from '@b2b/common/services/api/types';
import uiRouter, { StateParams, StateProvider } from '@uirouter/angularjs';
import angular from 'angular';
import { PartnersDetailControllerModule } from './controllers/PartnersDetailController';

export const PartnersDetailView = angular
  .module('acme.view.application.partners.detail', [
    uiRouter,
    'ui.bootstrap',
    'acme.common.service.api',
    'acme.common.directive.history',
    'acme.common.directive.paymentOptions',
    PartnersDetailControllerModule,
    'acme.view.application.partners.detail.membership',
  ])
  .config(function config($stateProvider: StateProvider) {
    $stateProvider.state({
      name: 'application.partners.detail',
      url: '/:id/detail',
      views: {
        'subview-main': {
          controller: 'PartnersDetailController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/partners/detail/detail.tpl.html',
        },
      },
      data: {
        pageTitle: 'Organization Information',
        enablePreferences: true,
      },
      resolve: {
        PartnerData: [
          '$stateParams',
          'ApiService',
          function ($stateParams: StateParams, ApiService: ApiService) {
            return ApiService.partners.detail($stateParams.id);
          },
        ],
        CategoriesData: [
          'ApiService',
          function (ApiService: ApiService) {
            return ApiService.partners.categories.list({
              page: 1,
              pageSize: -1,
              sortDirection: 'asc',
              sortField: 'name',
            });
          },
        ],
      },
    });
  }).name;
